<template>
  <div class="space-y-4">
    <div v-for="(item, index) in items" :key="item.id || index">
      <div class="flex items-center">
        <img :src="item?.thumb?.url || ''" :alt="item?.thumb?.label || ''" class="w-8 h-8 object-contain" />
        <span class="ml-2 text-primary-1-100 text-sm">{{ item.name }}</span>
        <QuantityInput v-model="item.qty" class="ml-auto" :max="item.stock || undefined" />
      </div>

      <Money class="ml-10 font-bold text-secondary-700" :value="item.price * item.qty" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductData } from '@robustastudio/e-commerce/common';

defineComponent({
  name: 'ProductGroupItemCustomizer',
});
const product = inject(PRODUCT_CONTEXT) as Ref<ProductData>;

const items = computed(() => {
  return product.value.groupItems;
});
</script>
